import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ORGANIZATION/BALANCE_REPORT';

export const {
    action: fetchReport,
    success: fetchReportSuccess,
    failed: fetchReportFailed,
} = createAction(
    `${domain}/FETCH_REPORT`,
    (organizationId, month) => ({organizationId, month}),
    (table, csvLink) => ({table, csvLink}),
);
